import type { FC } from "react";

import { Text } from "../Text";

interface FormCheckboxProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Shared form checkbox component with consistent styling
 * Matches TaskActivityFilters reference tokens
 */
export const FormCheckbox: FC<FormCheckboxProps> = ({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  className = "",
}) => (
  <label
    className={`flex cursor-pointer select-none items-start gap-3 ${disabled ? "opacity-50" : ""} ${className}`}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      disabled={disabled}
      className="mt-0.5 h-4 w-4 rounded-none border border-slate-300 bg-white text-emerald-500 transition-colors focus:ring-2 focus:ring-emerald-500/30 dark:border-slate-700 dark:bg-arti-background dark:checked:border-emerald-500 dark:checked:bg-emerald-500"
    />
    <span className="flex flex-col gap-1">
      <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-slate-700 dark:text-slate-300">
        {label}
      </span>
      {description && (
        <Text className="font-mono text-[10px] text-slate-500 dark:text-slate-400">
          {description}
        </Text>
      )}
    </span>
  </label>
);
